const Table = {
  tableColumns: [],
  pagination: {
    perPage: 10,
    currentPage: 1,
    perPageOptions: [5, 10, 25, 50],
    total: 0,
  },
};

const Search = {
  pagedData() {
    return this.tableData.slice(this.from, this.to);
  },

  /***
   * Searches through table data and returns a paginated array.
   * Note that this should not be used for table with a lot of data as it might be slow!
   * Do the search and the pagination on the server and display the data retrieved from server instead.
   * @returns {computed.pagedData}
   */
  queriedData() {
    let result = this.tableData;
    if (this.searchQuery !== '') {
      result = this.fuseSearch.search('=' + this.searchQuery + '');
    }

    this.pagination.total = result.length;

    if (this.$refs.cardfooter) {
      this.$refs.cardfooter.totals = this.pagination.total;
    }

    return result.slice(this.from, this.to);
  },

  to() {
    let highBound = Number(this.from) + Number(this.pagination.perPage);
    if (this.total < highBound) {
      highBound = this.total;
    }

    if (this.$refs.cardfooter) {
      this.$refs.cardfooter.tos = highBound;
    }

    return highBound;
  },

  from() {
    let from = this.pagination.perPage * (this.pagination.currentPage - 1);
    if (this.$refs.cardfooter) {
      this.$refs.cardfooter.froms = from;
    }

    return from;
  },

  total() {
    if (this.$refs.cardfooter) {
      this.$refs.cardfooter.totals = this.pagination.total;
    }

    return this.pagination.total;
  },
};

export default { Table, Search };
